<template>
  <CCardWithBorder
    ref="mapCardRef"
    class="home-view-map-card"
    :style="{ height: finalHeight }"
  >
    <HomeMap
      :highlighted-vending-machine-id="highlightedVendingMachineId"
      :location="location"
    />
  </CCardWithBorder>
</template>

<script setup lang="ts">
  import { computed, onMounted, onUnmounted, ref } from 'vue';
  import type { YMapLocationRequest } from '@yandex/ymaps3-types';

  import { useClientSize } from '@/composables/useClientSize';

  import CCardWithBorder from '../Cards/CCardWithBorder.vue';
  import HomeMap from '../Map/HomeMap.vue';

  defineProps<{
    highlightedVendingMachineId?: number | null;
    location?: YMapLocationRequest;
  }>();

  const { isMobile } = useClientSize();

  const mapCardRef = ref<InstanceType<typeof CCardWithBorder> | null>(null);

  const width = ref(0);

  const finalHeight = computed(() => {
    if (isMobile.value) {
      return width.value ? `${width.value}px` : '300px';
    }

    return undefined;
  });

  function getWidth() {
    const elWidth = mapCardRef.value?.$el?.getBoundingClientRect().width;

    if (elWidth) {
      width.value = elWidth;
    }
  }

  function onResize() {
    getWidth();
  }

  onMounted(() => {
    window.addEventListener('resize', onResize);
    getWidth();
  });

  onUnmounted(() => {
    window.removeEventListener('resize', onResize);
  });
</script>

<style>
  .home-view-map-card {
    width: calc(50% - 22px);
    min-height: 500px;
    flex-shrink: 0;
  }

  @media (--mobile) {
    .home-view-map-card {
      width: auto;
      min-height: unset;
    }
  }
</style>
